var map = {
	"./10_nuts.png": 2595,
	"./1drink_12beer.png": 2596,
	"./1serving_8ounces.png": 2597,
	"./1serving_8ounces2.png": 2598,
	"./1serving_8ounces3.png": 2599,
	"./1serving_8ounces4.png": 2600,
	"./1serving_8ounces5.png": 2601,
	"./8ounces_1glass.png": 2602,
	"./can_1.png": 2603,
	"./can_2.png": 2604,
	"./can_3.png": 2605,
	"./cup.png": 2606,
	"./dried_serving_1/4cup.png": 2607,
	"./dried_serving_1:4cup.png": 2608,
	"./fresh_serving_1cup.png": 2609,
	"./glass_1.png": 2610,
	"./glass_2.png": 2611,
	"./golfball.png": 2612,
	"./halfthumb.png": 2613,
	"./hand_1.png": 2614,
	"./hand_2.png": 2615,
	"./hand_3.png": 2616,
	"./hand_4.png": 2617,
	"./hand_5.png": 2618,
	"./how.png": 835,
	"./serving_1/2cup.png": 2619,
	"./serving_1:2cup.png": 2620,
	"./serving_1tbsp.png": 2621,
	"./serving_3/4ounces.png": 2622,
	"./serving_3:4ounces.png": 2623,
	"./thumbx2.png": 2624,
	"./usda.png": 2625,
	"./vegetables_1cup.png": 2626,
	"./what.png": 833,
	"./wholethumb.png": 2627,
	"./why.png": 834
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2594;